// extracted by mini-css-extract-plugin
export default {"createProjectDialog":"CreateProjectDialog-module__createProjectDialog__+J4Tq"};